import styled from "styled-components";

export const CloseModalWrapper = styled.div`
    position: absolute;
    top: 10px;
    right: 10px;
`;